import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import {
  createSubCategory,
  editSubCategory,
  getSubCategoriesByPage,
} from '../../ApiServices/SubCategoriesService';
import { t } from 'i18next';
import { handleResponse } from '../../ApiServices/ApiHandler';

export const initialState = {
  value: { totalCount: -1, data: [] },
  loading: false,
  error: null,
  selectedValue: null,
  message: null,
  rowsPerPage: 10,
  pageNo: 0,
  filter: {},
};

const subCategorySlice = createSlice({
  name: 'subCategory',
  initialState: initialState,
  reducers: {
    clearSubCategoryState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.message = null;
      state.filter = initialState.filter;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSubCategories.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
      state.filter = action?.meta?.arg;
    });
    builder.addCase(fetchSubCategories.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
      state.filter = action?.meta?.arg;
    });
  },
});

export const subCategoryState = (state: RootState) => state?.subCategory;
export const { clearSubCategoryState } = subCategorySlice.actions;
export default subCategorySlice.reducer;

export const fetchSubCategories = createAsyncThunk(
  'subCategory/fetchSubCategories',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_SUBCATEGORIES') }));
      return fulfillWithValue(await getSubCategoriesByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const addSubCategory = createAsyncThunk(
  'subCategory/addSubCategory',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('ADDING_NEW_SUB_CATEGORY_DETAILS') }));
      let response: any = await createSubCategory(payload);
      if (response?.status === 200 || response === 200) {
        dispatch(
          showSuccessSnackbar({ message: t('SUBCATEGORY_ADDED_SUCCESS') })
        );
        return fulfillWithValue(response);
      } else {
        dispatch(showErrorSnackbar({ message: t('SUBCATEGORY_ADD_FAILED') }));
        return rejectWithValue(response);
      }
      // return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const modifySubCategory = createAsyncThunk(
  'subCategory/modifySubCategory',
  async (payload: any, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      dispatch(showLoader({ message: t('UPDATING_SUBCATEGORIES_DETAILS') }));
      let response: any = await editSubCategory(payload);
      if (response?.status === 200 || response === 200) {
        dispatch(
          showSuccessSnackbar({ message: t('ORDER_STATUS_CHANGED_SUCCESS') })
        );
        return fulfillWithValue(response);
      } else {
        dispatch(
          showErrorSnackbar({ message: t('ORDER_STATUS_CHANGE_FAILED') })
        );
        return rejectWithValue(response);
      }
      // return await handleResponse(
      //   response,
      //   fulfillWithValue,
      //   rejectWithValue,
      //   dispatch
      // );
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const downloadSubCategories = createAsyncThunk(
  'subCategory/downloadSubCategories',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('DOWNLOADING_SUBCATEGORIES') }));
      let response: any = await getSubCategoriesByPage(payload);
      if (response === 200)
        dispatch(showSuccessSnackbar({ message: t('DOWNLOAD_SUCCESS') }));
      else dispatch(showErrorSnackbar({ message: t('DOWNLOAD_FAILS') }));
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
